import * as plans from './planTypes';
import staticUrl from "../utils/staticPath";

// The links to the feature pages need to be absolute as other SKU's such as AYSO don't have these pages on their marketing site

export const DIAGRAM = {
  feature: 'diagram',
  title: 'It\'s as easy as pen and paper',
  summary: `We’ve created the easiest to use Diagram Creator on the market - upgrade to a <strong>${plans.PREMIUM}</strong> or <strong>${plans.ENTERPRISE}</strong> subscription today to see for yourself. <a href="https://thecoachingmanual.com/features/session-planner" target="_blank">Learn more</a>.`,
  minAccess: plans.PREMIUM,
  imageSrc: `${staticUrl()}assets/images/raster/features/diagram.png`,
};

export const PRACTICE = {
  feature: 'practice',
  title: 'Spend less time planning and more time on the field',
  summary: `Add details, key coaching points, diagrams, videos, images and more - upgrade to a <strong>${plans.PREMIUM}</strong> or <strong>${plans.ENTERPRISE}</strong> subscription today to get started. <a href="https://thecoachingmanual.com/features/session-planner" target="_blank">Learn more</a>.`,
  minAccess: plans.PREMIUM,
  imageSrc: `${staticUrl()}assets/images/raster/features/practice.png`,
};

export const DOCUMENT = {
  feature: 'document',
  title: 'Share vital information with your team',
  summary: `Add diagrams, videos, images, coaching standards, player standards, club philosophy and anything else you can think of to our intuitive Document Creator and share through your folders - upgrade to a <strong>${plans.PREMIUM}</strong> or <strong>${plans.ENTERPRISE}</strong> subscription today to get started. <a href="https://thecoachingmanual.com/features/session-planner" target="_blank">Learn more</a>.`,
  minAccess: plans.PREMIUM,
  imageSrc: `${staticUrl()}assets/images/raster/features/folders.png`,
};

export const SESSION = {
  feature: 'session',
  title: 'Create your own coaching legacy',
  summary: `Create full sessions and easily share with your coaches and players - upgrade to a <strong>${plans.PREMIUM}</strong> or <strong>${plans.ENTERPRISE}</strong> subscription today to create your own sessions. <a href="https://thecoachingmanual.com/features/session-planner" target="_blank">Learn more</a>.`,
  minAccess: plans.PREMIUM,
  imageSrc: `${staticUrl()}assets/images/raster/features/session.png`,
};

export const FOLDERS = {
  feature: 'folders',
  title: 'Organise your content and share with your team',
  summary: `Add diagrams, practices and sessions to a folder to help organise your content, then share with your team - sign up for a free <strong>${plans.BASIC}</strong> subscription today to create your first folder.`,
  minAccess: plans.BASIC,
  imageSrc: `${staticUrl()}assets/images/raster/features/folders.png`,
};

export const FAVOURITE = {
  feature: 'favourite',
  title: 'Bookmark your favourite content',
  summary: `Bookmark all of your favourite content and easily refer back to it later - sign up for a free <strong>${plans.BASIC}</strong> subscription today to favourite this content.`,
  minAccess: plans.BASIC,
  imageSrc: `${staticUrl()}assets/images/raster/features/favourite.png`,
};

export const LICENCES = {
  feature: 'licences',
  title: 'Easily allocate and track your licences',
  summary: `Allocating licences allows you to upgrade other users of The Coaching Manual without them having to pay themselves - upgrade to an <strong>${plans.ENTERPRISE}</strong> subscription today to allocate licences.`,
  minAccess: plans.ENTERPRISE,
};



// WEBPACK FOOTER //
// ./library/app/data/featureUpselling.js